import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function ConfiguracaoImpressora() {
  const [printerName, setPrinterName] = useState("");
  const [showToast, setShowToast] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const saved = localStorage.getItem("printerName");
    if (saved) setPrinterName(saved);
  }, []);

  const handleSave = () => {
    if (!printerName.trim()) return;

    localStorage.setItem("printerName", printerName);

    setShowToast(true);

    // Ocultar toast + redirecionar
    setTimeout(() => {
      setShowToast(false);
      navigate("/dashboard");
    }, 1800);
  };

  return (
    <div className="container mt-5" style={{ maxWidth: "600px" }}>
      {/* 🔔 TOAST REACT PERSONALIZADO */}
      {showToast && (
        <div
          className="position-fixed top-0 end-0 p-3"
          style={{ zIndex: 9999 }}
        >
          <div
            className="alert alert-success shadow fade show"
            style={{
              animation: "fadeIn 0.3s ease",
              minWidth: "260px",
            }}
          >
            Impressora <strong>{printerName}</strong> salva com sucesso!
          </div>
        </div>
      )}

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>

      <div className="card shadow p-4">
        <h2 className="text-center mb-3">Configuração de Impressora</h2>

        <p className="text-muted text-center">
          Digite exatamente o nome da impressora instalada no seu computador / VirtualHere.
        </p>

        <input
          type="text"
          className="form-control mb-3"
          placeholder="Ex: Elgin i8, MP-4200 TH"
          value={printerName}
          onChange={(e) => setPrinterName(e.target.value)}
        />

        <button className="btn btn-primary w-100" onClick={handleSave}>
          Salvar Impressora
        </button>
      </div>
    </div>
  );
}

export {};
